import { VehicleType } from 'src/constants/partnerDriver/enums'
import type { CompleteVehicleInsurancePayload } from 'src/interfaces/partnerDriver'
import type { CompleteVehicleInsuranceFormValues } from './CompleteVehicleInsuranceForm.interface'

const VEHICLE_TYPES: string[] = Object.values(VehicleType)

export const toCompleteVehicleInsurancePayload = (
  stepId: string,
  values: CompleteVehicleInsuranceFormValues,
): CompleteVehicleInsurancePayload | null => {
  if (!values.insuranceDocument || !VEHICLE_TYPES.includes(values.vehicleType)) {
    return null
  }

  return {
    stepId,
    insuranceDocument: values.insuranceDocument,
    policyDocument: values.policyDocument,
    vehicleType: values.vehicleType as VehicleType,
    year: values.year.trim(),
    carMake: values.carMake.trim(),
    carModel: values.carModel.trim(),
    vin: values.vin.trim(),
  }
}
